import theme from "theme";
import SC from "./style";
import addFolder from "../../../../../assets/addFolder.png";
import { Button } from "InnoUI/components";

const NoProject = (props) => {
  const { handleAddOpenModal } = props;
  return (
    <>
      <SC.FolderStructureContainer>
        <div style={{ marginBottom: "150px" }}>
          <Button
            caption={"+ New Folder"}
            type="submit"
            color="white"
            onClick={handleAddOpenModal}
            fontSize="12px"
            style={{
              background: theme.gradient.themeGradient,
              color: theme.colors.white,
              minWidth: "100px",
              height: "30px",
              borderRadius: "3px",
            }}
          />
        </div>
      </SC.FolderStructureContainer>
    </>
  );
};

export default NoProject;
